// GiftCertificate/GiftCertificateCard.tsx

import React from 'react';
import {Link} from 'react-router-dom';
import {FC} from "WideLayout/Layouts";
import {useTheme} from "Theme/ThemeContext";
import {IGiftCertificate} from "../../Types/commerce/gift_certificate";

interface GiftCertificateCardProps {
    giftCertificate: IGiftCertificate;
}

const GiftCertificateCard: React.FC<GiftCertificateCardProps> = ({giftCertificate}) => {
    const {plt} = useTheme();
    return (
        <FC
            p={2}
            rounded={3}
            maxW={350}
            bg={`${plt.colors.secondary.light}33`}
            color={plt.text.primary80}
        >
            <Link
                to={`/gift-certificate/${giftCertificate.id}`}
                style={{color: plt.text.primary80}}
                className="text-decoration-none flex-grow-1"
            >
                <FC g={1} h={'100%'}>
                    <FC>
                        <h5>{giftCertificate.name}</h5>
                        <p style={{whiteSpace: 'pre-wrap'}}>{giftCertificate.description}</p>
                    </FC>
                    <FC mt={'auto'}>
                        <span>Цена: {giftCertificate.prices[0]?.amount} {giftCertificate.prices[0]?.currency}</span>
                    </FC>
                </FC>
            </Link>
        </FC>
    );
};

export default GiftCertificateCard;
